import { useState, useCallback } from 'react';
import { useErrorHandler } from './errorHandling';

export const useApiCall = () => {
    const [isLoading, setIsLoading] = useState(false);
    const [data, setData] = useState(null);
    const { 
        errors,
        setApiError,
        clearApiError,
        hasApiError
    } = useErrorHandler();

    const executeApiCall = useCallback(async (apiFunction, options = {}) => {
        const {
            onSuccess,
            onError,
            transformResponse,
            resetDataOnCall = true,
            storeResponse = true
        } = options;

        try {
            setIsLoading(true);
            clearApiError();
            
            if (resetDataOnCall) {
                setData(null);
            }

            const response = await apiFunction();
            
            if (storeResponse) {
                const transformedData = transformResponse ? transformResponse(response) : response;
                setData(transformedData);
                
                if (onSuccess) {
                    onSuccess(transformedData);
                }
                
                return transformedData;
            }

            if (onSuccess) {
                onSuccess();
            }

            return response;

        } catch (error) {
            console.error('API Error:', error);
            const errorMessage = 'An unexpected error occurred. Please try again.';
            
            setApiError(errorMessage);

            if (onError) {
                onError(error);
            }

            throw error;
        } finally {
            setIsLoading(false);
        }
    }, [clearApiError, setApiError, setIsLoading, setData]);

    return {
        isLoading,
        errors,
        hasApiError,
        data,
        executeApiCall,
        setData,
        setApiError,
        clearApiError
    };
};